<template>
  <div class="user-credential-page">
    <div ref="printContent" class="credential-card">
      <h1 class="credential-title">Hellokid 課程購買憑據</h1>

      <div class="section">
        <h2 class="section-title">課程方案資料</h2>
        <div class="info-row">
          <div class="info-item">
            <span class="info-label">訂單編號：</span>
            <span class="info-value">{{ orderNum }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">購買日期：</span>
            <span class="info-value">{{ orderDate }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="info-label">學員ID：</span>
            <span class="info-value">{{ userId }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">學員姓名：</span>
            <span class="info-value">{{ nickName }}</span>
          </div>
        </div>
      </div>

      <table class="detail-table">
        <thead>
          <tr>
            <th class="col-project">項目</th>
            <th class="col-detail">詳情</th>
            <th class="col-total">合計總金額</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>基礎方案</td>
            <td>{{ basePlanDetail }}</td>
            <td>{{ amount }} {{ currencyLabel }}</td>
          </tr>
          <tr v-if="hasActivity">
            <td>活動明細</td>
            <td>
              <ul class="activity-list">
                <li v-if="discountNum > 0">•&emsp;{{ discountNum }}節一對一外教課</li>
                <li v-if="discount > 0">•&emsp;現金優惠{{ discount }}{{ currencyLabel }}</li>
              </ul>
            </td>
            <td>—</td>
          </tr>
          <tr class="total-row">
            <td>合計</td>
            <td>{{ totalLessons }}</td>
            <td>{{ payAmount }} {{ currencyLabel }}</td>
          </tr>
        </tbody>
      </table>

      <div class="section">
        <h2 class="section-title">確認資料</h2>
        <div class="info-row">
          <div class="info-item">
            <span class="info-label">開票單位：</span>
            <span class="info-value">香港邦德爾科技有限公司</span>
          </div>
          <div class="info-item signer-item">
            <span class="info-label">簽單人：</span>
            <div class="signer-name-block">
              <span class="info-value">{{ createUser }}</span>
              <img class="company-seal" src="/static/bangder-seal.jpg" alt="公章">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="credential-toolbar not-print">
      <div class="toolbar_inbox">
<!--        <button class="toolbtn" @click="cancelPrint">放棄打印</button>-->
        <button class="toolbtn" @click="printWeb">打印本憑據</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderNum: '',
      orderDate: '',
      userId: '',
      nickName: '',
      amount: '',
      payAmount: '',
      discount: '',
      discountNum: '',
      num: '',
      livingNum: '',
      chineseNum: '',
      createUser: '',
      tchChannel: '1'
    }
  },
  computed: {
    currencyLabel () {
      return this.tchChannel === 2 ? '人民币' : '港币'
    },
    basePlanDetail () {
      const parts = []
      if (this.num) parts.push(this.num + '節一對一外教課')
      if (this.livingNum) parts.push(this.livingNum + '節直播課')
      if (this.chineseNum) parts.push(this.chineseNum + '節中教課')
      return parts.join('+')
    },
    totalLessons () {
      const parts = []
      const totalOneOnOne = (Number(this.num) || 0) + (Number(this.discountNum) || 0)
      if (totalOneOnOne) parts.push(totalOneOnOne + '節一對一外教課')
      if (this.livingNum) parts.push(this.livingNum + '節直播課')
      if (this.chineseNum) parts.push(this.chineseNum + '節中教課')
      return parts.join('+')
    },
    hasActivity () {
      return (this.discountNum && Number(this.discountNum) > 0) || (this.discount && Number(this.discount) > 0)
    }
  },
  mounted: function () {
    let self = this
    this.orderNum = this.$route.query.orderSn
    this.$http.post('/fundPackage/getFundPackage', { orderSn: this.orderNum }).then(function (res) {
      if (res.data.id <= 17209) {
        self.$router.push({ path: '/order/userCredential2?orderSn=' + res.data.orderId })
        return
      }
      let time = new Date((res.data.createTime) * 1000)
      self.orderDate = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日'
      self.userId = res.data.uid
      self.nickName = res.data.nickname
      self.amount = res.data.amount
      self.payAmount = res.data.payAmount
      self.discount = res.data.discount
      self.discountNum = res.data.discountNum
      self.num = res.data.num
      self.livingNum = res.data.livingNum
      self.chineseNum = res.data.chineseNum
      self.createUser = res.data.creatorName
      self.tchChannel = res.data.tchChannel
    })
  },
  methods: {
    cancelPrint () {
      this.$router.push({ path: '/order/fundPackageList' })
    },
    printWeb () {
      const content = this.$refs.printContent.innerHTML
      const iframe = document.createElement('iframe')
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;'
      document.body.appendChild(iframe)

      const doc = iframe.contentWindow.document
      doc.open()
      doc.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>课程购买凭据</title>
  <style>
    @page { margin: 1.5cm; }
    body { font-family: "Microsoft YaHei", "PingFang SC", sans-serif; color: #202124; margin: 0; padding: 0; }
    .credential-card { background: #fff; border: 1px solid #e0e0e0; border-radius: 8px; padding: 48px; max-width: 800px; margin: 0 auto; box-sizing: border-box; }
    .credential-title { font-size: 28px; font-weight: bold; text-align: center; margin: 0 0 40px; color: #202124; }
    .section { margin-bottom: 32px; }
    .section-title { font-size: 19px; font-weight: bold; color: #202124; margin: 0 0 16px; }
    .info-row { display: flex; margin-bottom: 12px; }
    .info-item { flex: 1; font-size: 16px; color: #202124; }
    .info-label { font-weight: bold; }
    .signer-item { display: flex; flex-direction: row; align-items: flex-start; }
    .signer-item .info-label { flex-shrink: 0; white-space: nowrap; }
    .signer-name-block { display: flex; flex-direction: column; align-items: flex-start; }
    .company-seal { width: 112px; height: auto; margin-top: 4px; pointer-events: none; }
    .detail-table { width: 100%; border-collapse: collapse; font-size: 16px; color: #202124; margin-bottom: 32px; }
    .detail-table th, .detail-table td { border: 1px solid #e0e0e0; padding: 12px 16px; text-align: left; vertical-align: top; }
    .detail-table th { background: #f8f9fa; font-weight: bold; }
    .detail-table .col-project { width: 20%; }
    .detail-table .col-detail { width: 55%; }
    .detail-table .col-total { width: 25%; }
    .detail-table .total-row { font-weight: bold; }
    .activity-list { margin: 0; padding: 0; list-style: none; }
    .activity-list li { margin-bottom: 4px; }
  </style>
</head>
<body>
  <div class="credential-card">${content}</div>
</body>
</html>`)
      doc.close()
      iframe.contentWindow.focus()
      setTimeout(() => {
        iframe.contentWindow.print()
      }, 250)

      const remove = () => { iframe.parentNode && iframe.parentNode.removeChild(iframe) }
      iframe.contentWindow.addEventListener('afterprint', remove)
      setTimeout(remove, 60000)
    }
  }
}
</script>

<style scoped lang="less">
.user-credential-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px 16px 120px;
}

.credential-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 48px;
}

.credential-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  color: #202124;
  margin: 0 0 40px;
}

.section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 19px;
  font-weight: bold;
  color: #202124;
  margin: 0 0 16px;
}

.info-row {
  display: flex;
  margin-bottom: 12px;
}

.info-item {
  flex: 1;
  font-size: 16px;
  color: #202124;
}

.info-label {
  font-weight: bold;
}

.signer-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .info-label {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

.signer-name-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  color: #202124;
  margin-bottom: 32px;

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 12px 16px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #f8f9fa;
    font-weight: bold;
  }

  .col-project {
    width: 20%;
  }

  .col-detail {
    width: 55%;
  }

  .col-total {
    width: 25%;
  }

  .total-row {
    font-weight: bold;
  }
}

.activity-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: 4px;
  }
}

.company-seal {
  width: 112px;
  height: auto;
  margin-top: 4px;
  pointer-events: none;
}

.credential-toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f0e6;
  border-top: 1px solid #e0e0e0;
  padding: 16px;
  z-index: 100;
}

.toolbar_inbox {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.toolbtn {
  display: inline-block;
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  background: #0b34f2;
  color: #fff;
  border: none;

  &:hover {
    background: darken(#0b34f2, 8%);
    color: #fff;
  }
}

@media (max-width: 768px) {
  .user-credential-page {
    padding: 12px 12px 100px;
  }

  .credential-card {
    padding: 24px;
    border-radius: 6px;
  }

  .credential-title {
    font-size: 22px;
    margin-bottom: 24px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .info-row {
    flex-direction: column;
    margin-bottom: 0;
  }

  .info-item {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .detail-table {
    font-size: 14px;

    th,
    td {
      padding: 8px;
      word-break: break-word;
    }

    .col-project {
      width: 22%;
    }

    .col-detail {
      width: 50%;
    }

    .col-total {
      width: 28%;
    }
  }

  .activity-list {
    padding-left: 16px;
  }

  .credential-toolbar {
    padding: 12px;
  }

  .toolbar_inbox {
    gap: 12px;
  }

  .toolbtn {
    padding: 8px 16px;
    font-size: 14px;
    flex: 1;
    text-align: center;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .credential-card {
    padding: 36px;
  }
}

@media print {
  .not-print {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// UserCredential.vue?161b8ee8